import { render, staticRenderFns } from "./selaSales.vue?vue&type=template&id=27f2c4b2"
import script from "./selaSales.vue?vue&type=script&lang=js"
export * from "./selaSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports